import { create } from 'zustand';
import { getNbIotDevices } from '../../../api/api';

export const useIotDevicesStore = create((set) => ({
  data: [],
  showModal: false,
  setShowModal: (showModal) => set({ showModal }),
  error: null,
  total: 0,

  fetchIotDevices: async (page, limit, filterValue, sortBy, sortOrder) => {
    set({ isLoading: true, error: null });

    await getNbIotDevices({
      page,
      limit,
      filterValue,
      sortBy,
      sortOrder,
      dataCb: (data) => {
        set({ data: data?.items || [], total: data?.count, isLoading: false });
      },
      errCb: (err) => {
        set({ error: err, isLoading: false });
      },
    });
  },
}));
